import { createAction } from 'redux-actions';

export const getTransferBalance = createAction(
  'GET_TRANSFER_BALANCE',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getTransferBalanceSuccess = createAction('GET_TRANSFER_BALANCE_SUCCESS');
export const getTransferBalanceFailure = createAction('GET_TRANSFER_BALANCE_FAILURE');
